import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SidebarComponent} from './sidebar.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {UserAvatarDirective} from '../../directives/user-avatar.directive';

@NgModule({
    imports: [ RouterModule, CommonModule, TranslateModule, MatTooltipModule, UserAvatarDirective ],
    declarations: [ SidebarComponent ],
    exports: [ SidebarComponent ]
})

export class SidebarModule {

  constructor() {

  }

}
